"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTradeDeskIframe = exports.getSiteUrl = exports.getLearnArticleUrl = exports.getGraphUserURI = exports.getGoogleAuthAppId = exports.getFacebookAuthAppId = exports.getCertAgent = exports.getCareerSiteUrl = exports.getBaseAwsApiUrl = exports.getBaseApiUrl = exports.getAuth0Scope = exports.getAuth0Domain = exports.getAuth0ClientId = exports.getAuth0Cache = exports.getAuth0Audience = exports.STUDIO_URL = exports.SR_WEBSITE_BANNER_CONTENTFUL_KEY = exports.SEARCH_MAX_BEDS = exports.SEARCH_MAX_BATHS = exports.SEARCH_DEFAULT_STARTING_INDEX = exports.SEARCH_DEFAULT_SORT_METHOD_ID = exports.SEARCH_DEFAULT_PRICE_LOW = exports.SEARCH_DEFAULT_PRICE_HIGH = exports.SEARCH_DEFAULT_PER_PAGE = exports.SEARCH_DEFAULT_MINIMUM_SQUARE_FEET = exports.SEARCH_DEFAULT_MAXIMUM_SQUARE_FEET = exports.SEARCH_DEFAULT_DISTANCE = exports.SEARCH_DEFAULT_BEDS = exports.SEARCH_DEFAULT_BATHS = exports.SEARCH_ALLOWED_DISTANCES = exports.NEWSROOM_WEBSITE_BANNER_CONTENTFUL_KEY = exports.LIVEPERSON_ENGAGEMENT = exports.LAMBDA_TOKEN = exports.GOOGLE_MAPS_API_KEY = exports.FS_DEV_EXISTS = exports.ENVIRONMENT = exports.DEFAULT_MAP_ZOOM = exports.DEFAULT_MAP_CENTER = exports.CH_COM_WEBSITE_BANNER_CONTENTFUL_KEY = exports.CH_ALERTS_CLOSED_KEY = exports.BASE_AWS_API_URL = exports.BASE_API_URL = exports.AUTOCOMPLETE_SEARCH_MIN_CHARS = exports.AUTOCOMPLETE_SEARCH_MAX_LIST = exports.ALERT_DISMISS_EXPIRE_MS = void 0;

var fs = _interopRequireWildcard(require("fs"));

var https = _interopRequireWildcard(require("https"));

var _react = _interopRequireDefault(require("react"));

var _auth0Properties, _auth0Properties2, _auth0Properties3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BASE_AWS_API_URL = process.env.NODE_ENV === 'production' ? '#{BASE_AWS_API_URL}' : 'https://api.claytonhomes.itg.cct-pubweb.com/';
exports.BASE_AWS_API_URL = BASE_AWS_API_URL;
var BASE_API_URL = process.env.NODE_ENV === 'production' ? '#{BASE_API_URL}' : 'https://dev.cmhinfo.biz/WebServices2/api/';
exports.BASE_API_URL = BASE_API_URL;
var ENVIRONMENT = process.env.NODE_ENV === 'production' ? '#{terraformEnvCode}' : 'dev';
exports.ENVIRONMENT = ENVIRONMENT;
var DEFAULT_MAP_CENTER = {
  lat: 37.850033,
  lng: -92.6500523
};
exports.DEFAULT_MAP_CENTER = DEFAULT_MAP_CENTER;
var DEFAULT_MAP_ZOOM = 5;
exports.DEFAULT_MAP_ZOOM = DEFAULT_MAP_ZOOM;
var SEARCH_DEFAULT_BATHS = 2;
exports.SEARCH_DEFAULT_BATHS = SEARCH_DEFAULT_BATHS;
var SEARCH_MAX_BATHS = 3;
exports.SEARCH_MAX_BATHS = SEARCH_MAX_BATHS;
var SEARCH_DEFAULT_BEDS = 3;
exports.SEARCH_DEFAULT_BEDS = SEARCH_DEFAULT_BEDS;
var SEARCH_MAX_BEDS = 5;
exports.SEARCH_MAX_BEDS = SEARCH_MAX_BEDS;
var SEARCH_DEFAULT_PRICE_LOW = 75000;
exports.SEARCH_DEFAULT_PRICE_LOW = SEARCH_DEFAULT_PRICE_LOW;
var SEARCH_DEFAULT_PRICE_HIGH = 150000;
exports.SEARCH_DEFAULT_PRICE_HIGH = SEARCH_DEFAULT_PRICE_HIGH;
var SEARCH_DEFAULT_DISTANCE = 50;
exports.SEARCH_DEFAULT_DISTANCE = SEARCH_DEFAULT_DISTANCE;
var SEARCH_DEFAULT_SORT_METHOD_ID = 2;
exports.SEARCH_DEFAULT_SORT_METHOD_ID = SEARCH_DEFAULT_SORT_METHOD_ID;
var SEARCH_DEFAULT_MINIMUM_SQUARE_FEET = 0;
exports.SEARCH_DEFAULT_MINIMUM_SQUARE_FEET = SEARCH_DEFAULT_MINIMUM_SQUARE_FEET;
var SEARCH_DEFAULT_MAXIMUM_SQUARE_FEET = 3000;
exports.SEARCH_DEFAULT_MAXIMUM_SQUARE_FEET = SEARCH_DEFAULT_MAXIMUM_SQUARE_FEET;
var SEARCH_DEFAULT_STARTING_INDEX = 0;
exports.SEARCH_DEFAULT_STARTING_INDEX = SEARCH_DEFAULT_STARTING_INDEX;
var SEARCH_DEFAULT_PER_PAGE = 11;
exports.SEARCH_DEFAULT_PER_PAGE = SEARCH_DEFAULT_PER_PAGE;
var SEARCH_ALLOWED_DISTANCES = [50, 100, 150, 200, 250, 300, 350, 400, 450, 500]; //The number of cities allowed in the dropdown for LocationInput's CityLocationList

exports.SEARCH_ALLOWED_DISTANCES = SEARCH_ALLOWED_DISTANCES;
var AUTOCOMPLETE_SEARCH_MAX_LIST = 12;
exports.AUTOCOMPLETE_SEARCH_MAX_LIST = AUTOCOMPLETE_SEARCH_MAX_LIST;
var AUTOCOMPLETE_SEARCH_MIN_CHARS = 3;
exports.AUTOCOMPLETE_SEARCH_MIN_CHARS = AUTOCOMPLETE_SEARCH_MIN_CHARS;
var GOOGLE_MAPS_API_KEY = 'AIzaSyB6AeGdWo-bwqqklp6kLGcOENfl3waZzYo';
exports.GOOGLE_MAPS_API_KEY = GOOGLE_MAPS_API_KEY;
var LAMBDA_TOKEN = '#{lambda_token}';
exports.LAMBDA_TOKEN = LAMBDA_TOKEN;
var STUDIO_URL = '#{STUDIO_URL}';
exports.STUDIO_URL = STUDIO_URL;
var FS_DEV_EXISTS = typeof fs.readFileSync !== 'undefined';
exports.FS_DEV_EXISTS = FS_DEV_EXISTS;
var ALERT_DISMISS_EXPIRE_MS = 86400000; // Number of milliseconds to wait after alert dismissed before displaying again. (e.g. 3600000 = 60 min, 86400000 = 24 hrs)

exports.ALERT_DISMISS_EXPIRE_MS = ALERT_DISMISS_EXPIRE_MS;
var CH_ALERTS_CLOSED_KEY = 'chAlertsClosed'; // Local storage key for tracking CH.com banner alerts that have been dismissed

exports.CH_ALERTS_CLOSED_KEY = CH_ALERTS_CLOSED_KEY;
var CH_COM_WEBSITE_BANNER_CONTENTFUL_KEY = '5Q1EgY9jcFAECVZR0KkB3t'; // Contentful key for CH.com Website Banner data

exports.CH_COM_WEBSITE_BANNER_CONTENTFUL_KEY = CH_COM_WEBSITE_BANNER_CONTENTFUL_KEY;
var SR_WEBSITE_BANNER_CONTENTFUL_KEY = '38MEJGsk9gLudXyN9ZNMN6'; // Contentful key for Social Responsibility Website Banner data

exports.SR_WEBSITE_BANNER_CONTENTFUL_KEY = SR_WEBSITE_BANNER_CONTENTFUL_KEY;
var NEWSROOM_WEBSITE_BANNER_CONTENTFUL_KEY = 'digsgYGidfOP3XNfh3HVQ'; // Contentful key for Newsroom Website Banner data

exports.NEWSROOM_WEBSITE_BANNER_CONTENTFUL_KEY = NEWSROOM_WEBSITE_BANNER_CONTENTFUL_KEY;
var LIVEPERSON_ENGAGEMENT = ENVIRONMENT === 'prod' || ENVIRONMENT === 'qua' ? {
  id: '2482410030',
  site: '45825951'
} : {
  id: '3559676130',
  site: '55568973'
};
exports.LIVEPERSON_ENGAGEMENT = LIVEPERSON_ENGAGEMENT;

var getCertAgent = function getCertAgent() {
  return (ENVIRONMENT === 'dev' || ENVIRONMENT === 'itg' || ENVIRONMENT === 'qua') && FS_DEV_EXISTS ? new https.Agent({
    ca: fs.readFileSync("./ClaytonRootCA.cer"),
    keepAlive: false
  }) : null;
};

exports.getCertAgent = getCertAgent;

var getFacebookAuthAppId = function getFacebookAuthAppId() {
  var tempEnv = ENVIRONMENT;
  var facebookAppId = '';

  switch (tempEnv) {
    default:
    case 'dev':
    case 'itg':
      facebookAppId = 493875048509420;
      break;

    case 'qua':
      facebookAppId = 204829764851793;
      break;

    case 'staging':
    case 'preview':
    case 'prod':
      facebookAppId = 1192460291230213;
      break;
  }

  return facebookAppId;
};

exports.getFacebookAuthAppId = getFacebookAuthAppId;

var getGoogleAuthAppId = function getGoogleAuthAppId() {
  var tempEnv = ENVIRONMENT;
  var googleAppId = '';

  switch (tempEnv) {
    default:
    case 'dev':
    case 'itg':
      googleAppId = '283083858501-gj3kudim1826e027ga06qq2hjlq5tkat.apps.googleusercontent.com';
      break;

    case 'qua':
      googleAppId = '267409802470-hcm74agkn05buh548ftrofjeduq3jpdb.apps.googleusercontent.com';
      break;

    case 'staging':
    case 'preview':
    case 'prod':
      googleAppId = '805270524988-o23cl91dphqtsee8bntiqktsipp2n9en.apps.googleusercontent.com';
      break;
  }

  return googleAppId;
};
/* For now, setting the default auth0 parameters to dev since there is not an entry for localhost */


exports.getGoogleAuthAppId = getGoogleAuthAppId;
var auth0Properties = {
  dev: {
    domain: 'auth.dev.myhomeaccount.com',
    clientId: 'x00zfFzI2KlQvnwzXtOk6rfXqhJdug1A',
    graphURI: 'https://api-clayton-dx-orchestration.dev.cct-pubweb.com/graphql'
  },
  itg: {
    domain: 'auth.itg.myhomeaccount.com',
    clientId: 'WeGuMNFFcUV3s5FSBMKHNOzlMGmDJGxh',
    graphURI: 'https://api-clayton-dx-orchestration.itg.cct-pubweb.com/graphql'
  },
  qua: {
    domain: 'auth.qua.myhomeaccount.com',
    clientId: 'kOfYMwpVnSRH5AxQ4dqC08eLlD9ZhiDW',
    graphURI: 'https://api-clayton-dx-orchestration.qua.cct-pubweb.com/graphql'
  },
  prod: {
    domain: 'auth.myhomeaccount.com',
    clientId: 'coWSMoUB3aVitc4TmbmZpr22InbWj2bq',
    graphURI: 'https://api.claytonhomes.com/graphql'
  }
};
var getAuth0Domain = (_auth0Properties = auth0Properties[ENVIRONMENT !== null && ENVIRONMENT !== void 0 ? ENVIRONMENT : 'dev']) === null || _auth0Properties === void 0 ? void 0 : _auth0Properties.domain;
exports.getAuth0Domain = getAuth0Domain;
var getAuth0ClientId = (_auth0Properties2 = auth0Properties[ENVIRONMENT !== null && ENVIRONMENT !== void 0 ? ENVIRONMENT : 'dev']) === null || _auth0Properties2 === void 0 ? void 0 : _auth0Properties2.clientId;
exports.getAuth0ClientId = getAuth0ClientId;
var getGraphUserURI = (_auth0Properties3 = auth0Properties[ENVIRONMENT !== null && ENVIRONMENT !== void 0 ? ENVIRONMENT : 'dev']) === null || _auth0Properties3 === void 0 ? void 0 : _auth0Properties3.graphURI;
exports.getGraphUserURI = getGraphUserURI;
var getAuth0Cache = 'localstorage';
exports.getAuth0Cache = getAuth0Cache;
var getAuth0Audience = 'myhome-api';
exports.getAuth0Audience = getAuth0Audience;
var getAuth0Scope = 'Corp:DX:Read Corp:DX:Write Global:Read:User Global:Write:User';
exports.getAuth0Scope = getAuth0Scope;

var getBaseAwsApiUrl = function getBaseAwsApiUrl() {
  return BASE_AWS_API_URL;
};

exports.getBaseAwsApiUrl = getBaseAwsApiUrl;

var getBaseApiUrl = function getBaseApiUrl() {
  return BASE_API_URL;
};

exports.getBaseApiUrl = getBaseApiUrl;

var getSiteUrl = function getSiteUrl() {
  var relativeUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var ssr = arguments.length > 1 ? arguments[1] : undefined;

  //This is to overstep a local issue where local develop uses the full path automatically.
  if ((relativeUrl === null || relativeUrl === void 0 ? void 0 : relativeUrl.indexOf('localhost')) !== -1) {
    return relativeUrl;
  }

  var domain = ENVIRONMENT.indexOf('terraformEnvCode') !== -1 ? 'localhost:3000' : "claytonhomes.".concat(ENVIRONMENT, ".cct-pubweb.com");

  if (ssr) {
    domain = ENVIRONMENT.indexOf('terraformEnvCode') !== -1 ? "claytonhomes.".concat(ENVIRONMENT, ".cct-pubweb.com") : 'localhost:3000';
  }

  if ("".concat(ENVIRONMENT) == 'dev') {
    domain = 'claytonhomes.dev.cct-pubweb.com';
  }

  if (ENVIRONMENT.indexOf('staging') !== -1 || ENVIRONMENT.indexOf('prod') !== -1) {
    domain = 'www.claytonhomes.com';
  }

  return "https://".concat(domain).concat(relativeUrl);
};

exports.getSiteUrl = getSiteUrl;

var getCareerSiteUrl = function getCareerSiteUrl() {
  var url = ENVIRONMENT === '#{terraformEnvCode}' || ENVIRONMENT === 'prod' || ENVIRONMENT === 'preview' || ENVIRONMENT === 'staging' ? 'https://careers.claytonhomes.com/' : "https://career-sites.".concat(ENVIRONMENT, ".cct-pubweb.com");
  return url;
};
/**
 * Get the link to the learn article
 * @param {string} categoryName category the article belongs to
 * @param {string} url article url slug
 * @returns {string} formatted url
 */


exports.getCareerSiteUrl = getCareerSiteUrl;

var getLearnArticleUrl = function getLearnArticleUrl(url) {
  if (!url) {
    throw new Error('url is required');
  }

  if (url.indexOf('http') === 0) {
    return url;
  }

  return "/studio/".concat(url);
};

exports.getLearnArticleUrl = getLearnArticleUrl;

var getTradeDeskIframe = function getTradeDeskIframe() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("iframe", {
    width: "0",
    height: "0",
    name: "Trade Desk Tracking - Corporate-Request Info Form",
    frameBorder: "0",
    scrolling: "no",
    src: "https://insight.adsrvr.org/tags/1um95m8/x3vd41s/iframe"
  }));
};

exports.getTradeDeskIframe = getTradeDeskIframe;